import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "37",
  viewBox: "0 0 28 37",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path d=\"M13.5 5.9825L8.35459 0H0L10.6331 13.0765L19.3834 9.42276L13.5 5.9825Z\" fill=\"#FF5C00\" fill-opacity=\"0.75\"></path><path d=\"M19.4441 0L14 6.26269L18.192 11.9868L19.1462 10.8211L27.9991 0H19.4441Z\" fill=\"#FF5C00\"></path><path d=\"M12.9651 7.10339C12.4298 7.21133 11.9088 7.40357 11.4193 7.67935L2.8083 12.5303C1.07637 13.5063 0 15.3805 0 17.4182V26.5811C0 28.6188 1.07637 30.4938 2.8083 31.469L11.4193 36.3207C13.0281 37.2264 14.9719 37.2264 16.5779 36.3207L25.1917 31.469C25.9761 31.0269 26.6259 30.4007 27.1011 29.6583C27.6765 28.7615 28 27.6953 28 26.5811V17.4182C28 15.3805 26.9236 13.5063 25.1917 12.5303L16.5779 7.67935C15.4614 7.04941 14.1818 6.85792 12.9651 7.10339Z\" fill=\"url(#paint0_linear_698_91751)\"></path><path d=\"M11.7187 24.104C12.4867 23.464 13.0987 22.932 13.5547 22.508C14.0107 22.076 14.3907 21.628 14.6947 21.164C14.9987 20.7 15.1507 20.244 15.1507 19.796C15.1507 19.388 15.0547 19.068 14.8627 18.836C14.6707 18.604 14.3747 18.488 13.9747 18.488C13.5747 18.488 13.2667 18.624 13.0507 18.896C12.8347 19.16 12.7227 19.524 12.7147 19.988H11.0827C11.1147 19.028 11.3987 18.3 11.9347 17.804C12.4787 17.308 13.1667 17.06 13.9987 17.06C14.9107 17.06 15.6107 17.304 16.0987 17.792C16.5867 18.272 16.8307 18.908 16.8307 19.7C16.8307 20.324 16.6627 20.92 16.3267 21.488C15.9907 22.056 15.6067 22.552 15.1747 22.976C14.7427 23.392 14.1787 23.896 13.4827 24.488H17.0227V25.88H11.0947V24.632L11.7187 24.104Z\" fill=\"white\"></path><defs><linearGradient id=\"paint0_linear_698_91751\" x1=\"14\" y1=\"7\" x2=\"14\" y2=\"37\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#CDD5DF\"></stop><stop offset=\"1\" stop-color=\"#AAB4C1\"></stop></linearGradient></defs>", 5)
const _hoisted_7 = [
  _hoisted_2
]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MedalSilver',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_7))
}
}

})